import React, { useState, useEffect } from 'react';
import { DatePicker as AntDatePicker } from 'antd';
import moment from 'moment';
import isString from 'lodash/isString';
import { validMomentFormat } from 'utils/helpers';
import { Label } from 'components';
import { ReactComponent as Calendar } from 'assets/icons/calendar.gov.svg';
import { dateFormatList } from 'utils';

const DatePicker = ({ label, value, asterisk, ...rest }) => {
  const [width, setWidth] = useState(0);
  const [userFocus, setUserFocus] = useState(false);
  const [openPopover, setOpenPopover] = useState(false);


  const validFormats = ["M/D/YYYY", "MM/DD/YYYY", "D/M/YYYY", "DD/MM/YYYY", moment.ISO_8601]; //accepted formats

  const formattedValue = validMomentFormat(value, validFormats);
  
  console.log("Datepicker ");

  useEffect(() => {
    const antPicker = document.querySelector('.ant-picker');
    // if (antPicker !== null) setWidth(antPicker.offsetWidth);
    if (antPicker !== null) setWidth('20%');
  }, []);  
  return (
    <>
      <Label label={label} asterisk={asterisk}/>
      <AntDatePicker
        {...rest}
        suffixIcon={<Calendar className="ant-calendar-icon" />}
        value={formattedValue}
        //disabledDate={d => !d || d.isAfter('2027-01-01')}
        //disabledDate={d => !d || d.isBefore(new Date((new Date()).valueOf() - 1000*60*60*24)) || d.isAfter('2027-01-01')}
        // disabledDate={d => !d }
        format={dateFormatList}
        allowClear={false}
        onKeyDown={(e) => {
          e.preventDefault();
          if (e.key === ' ') { // manually open the popover on pressing Space to mimic normal keyboard functions (otherwise in will only open on click)
            e.preventDefault(); // Prevent the page from scrolling on Space
            setOpenPopover(true);
          }
       }}
       open = {openPopover} 
       onClick={()=> setUserFocus(true)} //track user click
       onOpenChange={(open) => {
         // Only open if it was triggered by an explicit click (avoid automatic open when auto focus from autocomplete)
         if (open && !userFocus) return;
         setOpenPopover(open); // manually control user state
         setUserFocus(false); // Reset after opening
       }}
        popupStyle={{ width }}
      />
    </>
  );
};

export default DatePicker;
